import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Button, Form, Input, Space ,Spin} from 'antd';
import { captchaConfig } from '../../utils/constants';
import Captcha from '../../components/Captcha.tsx';
import s from './style.module.less';
import { rules, regular } from 'grt-tool-lib-front';
import { LoadingOutlined } from '@ant-design/icons';
// const { registerRule, checkIsMobile, checkRequired } = rules;
const { checkRequired } = rules;

@inject('store')
@observer
class UpdateTel extends Component {
    constructor(props) {
        super(props);
        this.myForm = React.createRef();
        this.myFormSecond = React.createRef();
        this.timeout = null;
        this.state = {
            captcha: {
                remoteUrl: captchaConfig.host,
                captchaId: captchaConfig.captchaId,
                onSuccess: this.captchaSuccess.bind(this)
            },
            smsCanClick: true,
            codeMessage: '获取验证码',
            yuyinShow: false,
            loading:false
        };
    }

    /**
     * 行为验证码验证成功回调
     * @param result
     */
    async captchaSuccess(result) {
        const {
            store: { login }
        } = this.props;

        login.setCaptchaVisible(false);

        let mobile = '';

        if (login.modifyMoblieStep === 1) {
            mobile = this.myForm.current.getFieldValue('mobile');
            const succcess = await login.getSmn({
                mobile,
                captcha_token: result.token,
                biz_type: 6, //1登录 2 忘记密码 3 修改密码 4管理员邀请 5学员邀请 6 验证手机号 7 修改手机号
                types: 1 //1短信2语音
            });

            if (succcess) {
                this.countDown(60);
            }
        } else {
            mobile = this.myFormSecond.current.getFieldValue('new_mobile');
            const succcess = await login.getSmn({
                mobile,
                captcha_token: result.token,
                biz_type: 7, //1登录 2 忘记密码 3 修改密码 4管理员邀请 5学员邀请 6 验证手机号 7 修改手机号
                types: 1 //1短信2语音
            });

            if (succcess) {
                this.countDown(60);
            }
        }
    }

    onFinishFirst = async (values) => {
        const {
                store: { login }
            } = this.props,
            success = await login.moblieVerifyFirst(values);

        if (success) {
            this.countDown(0);
            this.setState({ smsCanClick: false, yuyinShow: false });
        }
    };

    onFinishSecond = (values) => {
        const {
            store: { login }
        } = this.props;

        login.moblieVerifySecond({ captcha: values.new_captcha, mobile: values.new_mobile, verify_token: login.moblie_verify_token });
    };

    yuyinSms = () => {
        const {
            store: { login }
        } = this.props;

        if (login.modifyMoblieStep === 1) {
            this.myForm.current.validateFields(['mobile']).then((values) => {
                login.getSmn({
                    mobile: values.mobile,
                    biz_type: 6, //1登录 2 忘记密码 3 修改密码 4管理员邀请 5学员邀请 6 验证手机号 7 修改手机号
                    types: 2 //1短信2语音
                });
            });
        } else {
            this.myFormSecond.current.validateFields(['new_mobile']).then((values) => {
                login.getSmn({
                    mobile: values.new_mobile,
                    biz_type: 7, //1登录 2 忘记密码 3 修改密码 4管理员邀请 5学员邀请 6 验证手机号 7 修改手机号
                    types: 2 //1短信2语音
                });
            });
        }
    };

    sendSmn = () => {
        const {
            store: { login }
        } = this.props;

        if (!this.state.smsCanClick) {
            return;
        }
        if (login.modifyMoblieStep === 1) {
            this.setState({loading: true},()=>{
                this.myForm.current.validateFields(['mobile']).then(async (values) => {
                    const succcess = await login.getSmn({
                        mobile: values.mobile,
                        biz_type: 6, //1登录 2 忘记密码 3 修改密码 4管理员邀请 5学员邀请 6 验证手机号 7 修改手机号
                        types: 1 //1短信2语音
                    });

                    if (succcess) {
                        this.countDown(60);
                    }else{
                        this.setState({ loading: false });
                    }
                });
            });

        } else {
            this.setState({loading: true},()=>{
                this.myFormSecond.current.validateFields(['new_mobile']).then(async (values) => {
                    const succcess = await login.getSmn({
                        mobile: values.new_mobile,
                        biz_type: 7, //1登录 2 忘记密码 3 修改密码 4管理员邀请 5学员邀请 6 验证手机号 7 修改手机号
                        types: 1 //1短信2语音
                    });

                    if (succcess) {
                        this.countDown(60);
                    }else{
                        this.setState({ loading: false });
                    }
                });
            });

        }

    };
    toggleLogin = () => {
        const {
            store: { login }
        } = this.props;

        login.setSettingMode('setting');
        login.setModifyMoblieStep(1);
    };

    onValuesChange = () => {
        this.myFormSecond.current
            .validateFields(['new_mobile'])
            .then(() => {
                this.setState({ smsCanClick: true });
            })
            .catch(({ errorFields }) => {
                if (errorFields.length) {
                    this.setState({ smsCanClick: false });
                }
            });
    };

    /**
     * 验证码读秒
     * @param time
     */

    countDown(time = 60) {
        const {
            store: { login }
        } = this.props;

        if (time === 0) {
            clearTimeout(this.timeout);
            this.setState({
                smsCanClick: true,
                codeMessage: '获取验证码',
                loading: false
            });
            return;
        }

        this.timeout = setTimeout(() => {
            if (time === 1) {
                clearTimeout(this.timeout);
                if (login.modifyMoblieStep === 2) {
                    this.onValuesChange();
                }
                this.setState({
                    smsCanClick: true,
                    codeMessage: '重新获取',
                    loading: false
                });
                return;
            }
            time--;
            this.setState({
                loading: false,
                codeMessage: `${time} s`,
                // yuyinShow: time < 45,
                smsCanClick: false
            });
            this.countDown(time);
        }, 1000);
    }

    render() {
        const {
            store: { login }
        } = this.props;

        return (
            <>
                <Captcha {...this.state.captcha} show={login.captchaVisible} />
                <h3 style={{ margin: '20px 0', fontSize: '24px' }}>修改手机号</h3>
                {login.modifyMoblieStep === 1 ? (
                    <>
                        <p style={{ margin: '20px 0' }}>第一步：验证原手机号</p>
                        <Form ref={this.myForm} validateTrigger="onBlur" name="basic" onFinish={this.onFinishFirst}>
                            <Form.Item
                                name="mobile"
                                initialValue={login.userInfo?.mobile}
                                rules={[
                                    {
                                        required: true,
                                        message: '请填写手机号'
                                    }
                                ]}
                            >
                                <Input disabled={true} placeholder="请输入手机号" />
                            </Form.Item>

                            <Form.Item
                                name="captcha"
                                validateTrigger="onChange"
                                rules={[
                                    checkRequired('请输入验证码'),
                                    () => ({
                                        validator: (_, value) => {
                                            if (!value) {
                                                return Promise.resolve();
                                            }
                                            if (value.length !== 6) {
                                                return Promise.reject('验证码格式错误');
                                            }
                                            if (!regular.isNum.test(value)) {
                                                return Promise.reject('验证码格式错误');
                                            }
                                            return Promise.resolve();
                                        }
                                    })
                                ]}
                                extra={
                                    this.state.yuyinShow ? (
                                        <div
                                            style={{
                                                textAlign: 'right',
                                                lineHeight: '24px',
                                                fontSize: '12px'
                                            }}
                                        >
                                            收不到验证码？<a onClick={this.yuyinSms}>尝试语音验证码</a>
                                        </div>
                                    ) : null
                                }
                            >
                                <Input
                                    placeholder="验证码"
                                    suffix={
                                        <Spin spinning={this.state.loading} indicator={<LoadingOutlined spin />} size="small">
                                            <span onClick={this.sendSmn} className={!this.state.smsCanClick ? s.disabled : s.abled}>
                                                {this.state.codeMessage}
                                            </span>
                                        </Spin>
                                    }
                                />
                            </Form.Item>
                            <a> &nbsp;</a>
                            <Form.Item>
                                <Space size={'large'}>
                                    <Button type="primary" htmlType="submit">
                                        下一步
                                    </Button>
                                    <Button onClick={this.toggleLogin}>取消</Button>
                                </Space>
                            </Form.Item>
                        </Form>
                    </>
                ) : (
                    <>
                        <p style={{ margin: '20px 0' }}>第二步：绑定新手机号</p>
                        <Form
                            name="second"
                            ref={this.myFormSecond}
                            onValuesChange={this.onValuesChange}
                            validateTrigger="onBlur"
                            onFinish={this.onFinishSecond}
                        >
                        {/* 管理端账号优化需求 运营端管理端修改手机不校验号端 先注释 */}
                        {/* <Form.Item name="new_mobile" rules={[checkRequired('请填写手机号'), registerRule(checkIsMobile, '手机号格式错误')]}> */}
                        <Form.Item name="new_mobile"
                                    rules={[
                                        { required: true, message: '请输入绑定手机号' },
                                        () => ({
                                            validator: (_, value) => {
                                                if (!value) {
                                                    return Promise.resolve();
                                                }
                                                if (!/^1[0-9]{10}$/.test(value)) {
                                                    return Promise.reject('请填写正确的11位手机号');
                                                }
                                                if (!/^[0-9]+$/.test(value)) {
                                                    return Promise.reject('仅支持输入数字');
                                                }
                                                return Promise.resolve();
                                            }
                                        })
                                    ]}>
                                <Input placeholder="请输入新手机号" />
                            </Form.Item>

                            <Form.Item
                                name="new_captcha"
                                validateTrigger="onChange"
                                rules={[
                                    checkRequired('请输入验证码'),
                                    () => ({
                                        validator: (_, value) => {
                                            if (!value) {
                                                return Promise.resolve();
                                            }
                                            if (value.length !== 6) {
                                                return Promise.reject('验证码格式错误');
                                            }
                                            if (!regular.isNum.test(value)) {
                                                return Promise.reject('验证码格式错误');
                                            }
                                            return Promise.resolve();
                                        }
                                    })
                                ]}
                                extra={
                                    this.state.yuyinShow ? (
                                        <div
                                            style={{
                                                textAlign: 'right',
                                                lineHeight: '24px',
                                                fontSize: '12px'
                                            }}
                                        >
                                            收不到验证码？
                                            <a onClick={this.yuyinSms}>尝试语音验证码</a>
                                        </div>
                                    ) : null
                                }
                            >
                                <Input
                                    placeholder="验证码"
                                    suffix={
                                        <Spin spinning={this.state.loading} indicator={<LoadingOutlined spin />} size="small">
                                            <span onClick={this.sendSmn} className={!this.state.smsCanClick ? s.disabled : s.abled}>
                                                {this.state.codeMessage}
                                            </span>
                                        </Spin>
                                    }
                                />
                            </Form.Item>
                            <a> &nbsp;</a>
                            <Form.Item>
                                <Space size={'large'}>
                                    <Button type="primary" htmlType="submit">
                                        确定
                                    </Button>
                                    <Button onClick={this.toggleLogin}>取消</Button>
                                </Space>
                            </Form.Item>
                        </Form>
                    </>
                )}
            </>
        );
    }
}

export default UpdateTel;
